import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { EntityName } from 'record-it-time-common/EntityName';
import { AppEntityManagerEntityTypesByEntityName } from '../../../classes/entities/AppEntityManagerEntityTypesByEntityName';
import { useEntityDeleteHandlerFactory } from './useEntityDeleteHandlerFactory';
export function useEntityDeleteHandler(entityName, entity, getName) {
  const $ = _c(6);
  let t0;
  if ($[0] !== entityName || $[1] !== getName) {
    t0 = {
      entityName,
      getName
    };
    $[0] = entityName;
    $[1] = getName;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const factory = useEntityDeleteHandlerFactory(t0);
  let t1;
  if ($[3] !== entity || $[4] !== factory) {
    t1 = factory(entity);
    $[3] = entity;
    $[4] = factory;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}